function intercomONFlag() {
  const {INTERCOME_HELP_CHAT} = process.env
  return INTERCOME_HELP_CHAT === "true";
}

export {intercomONFlag}